import { Avatar } from '@material-ui/core'
import React, { useState , useEffect} from 'react'
import './Postarea.css'
import VideocamIcon from '@material-ui/icons/Videocam';
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';
import InsertEmoticonIcon from '@material-ui/icons/InsertEmoticon';
import Feed from '../component/Feed';
import db, { database } from '../firebase';
import firebase, { firestore }  from 'firebase';




function GetSortOrder(prop) {    
    return function(a, b) {    
        if (a[prop] < b[prop]) {    
            return 1;    
        } else if (a[prop] > b[prop]) {  
            return -1;    
        }    
        return 0;    
    }    
}   

function Postarea({user}) {
            const [postText,setPostText] = useState('');
            const [postImage,setPostImage] = useState('');
            const [feed,setFeed]= useState();

    useEffect(() => {   
            db.collection('post').orderBy('timestamp', 'desc').onSnapshot( (snapshot) =>setFeed(snapshot.docs.map( docs => ( {  id :docs.id,data: docs.data()}))) );
             }, [])
             
    const handleChange1 = e => {
            setPostText(e.target.value);
   }
   const handleChange2 = e => {
        setPostImage(e.target.value);
   }

   const handleLike = (id) => {

   //  var liked =  db.collection('post').onSnapshot(snapshot =>  console.log( snapshot.docs.filter(data => data.id ===id)[0].data().liked )  );
    var data  = db.collection('post').doc(id);
    data.update({
        liked : firebase.firestore.FieldValue.arrayUnion({email : user.email})
    })
   }
   
   const handleDislike = (id) =>{

    var data  = db.collection('post').doc(id);
    data.update({
        liked : firebase.firestore.FieldValue.arrayRemove({email : user.email})
    }) 
   }

   const handleCommentText = (com , id , photoURL , displayName ) => { 
   
    var data =  db.collection('post').doc(id);
    data.update({
        commentText : firebase.firestore.FieldValue.arrayUnion({comment : com , id : id , profile : photoURL , name : displayName  }),
        comments : firebase.firestore.FieldValue.increment(1)
    })
    
    
    
  /*
       const comments = feed.filter(post => post.id !==id );
       const NewComment = feed.filter(post => post.id ===id);
       NewComment[0].commentText = [...NewComment[0].commentText,{"id":NewComment[0].commentText.length + 1, "comment": com ,"name": user.displayName,'profile':user.photoURL}];
       setFeed([...comments,NewComment[0]]);
       console.log(NewComment[0]);
  */  
   }
 
   const HandleSubmit = e =>{
        e.preventDefault();
        db.collection('post').add({
            'name':`${user.displayName}`,'profile':`${user.photoURL}`, 'feedText':`${postText}` ,'feedImage': `${postImage}`,'liked':[],"commentText" : [] , "timestamp" : firebase.firestore.FieldValue.serverTimestamp(),"email" : `${user.email}`});
        setPostImage('');
        setPostText('');
    }

    const handleDelete = (id) => {
        db.collection('post').doc(id).delete();
    }

    
    return (
        <div className="Postarea">
            <div className="editPost">
                <div className="PostHead">
            
                    <Avatar src={user.photoURL} />
                    <form onSubmit={HandleSubmit} >
                        <div className="postInput flex-1">
                            <input placeholder={"What is in your mind " + user.displayName + " ?" }  value={postText} onChange={handleChange1}  ></input>
                        </div>
                        <div className="postInput">

                        <input placeholder='Image URl'value={postImage} onChange={handleChange2} ></input>
                        </div>
                        <button className="hPost" type="submit">Post</button>
                    </form>

                </div>
      
         
            <div className="postOptions">
                        <div className="pOption">
                            <VideocamIcon fontSize='large' style={{color: 'red'}} /> 
                            <h4>

                            Camera
                            </h4>
                        </div>
                        <div className="pOption">
                            <PhotoLibraryIcon fontSize='large' style={{color: 'green'}} />
                            <h4> 
                            Photos/Videos

                            </h4>
                        </div>
                        <div className="pOption">
                            <InsertEmoticonIcon fontSize='large' style={{color:'orange' }} />
                            <h4>Emotion</h4>
                        </div>
                </div>

               
       </div>
    

       {feed? feed.map(post => <Feed key={post.id} email={post.data.email} id={post.id} postusername={post.data.name} user={user} postuserprofile={post.data.profile} feedText={post.data.feedText} feedImage={post.data.feedImage} likes={post.data.liked.length} commentNo={post.data.commentText.length} HandleCommentText={handleCommentText} commentText={post.data.commentText} LikeFunction={handleLike} DislikeFunction={handleDislike} Liked={post.data.liked} HandleDelete={handleDelete}></Feed> ) : <></> }
    
           
        </div>
     
    )
}

export default Postarea
